import { MODULE_LINK_TYPE } from '../constants';
export const ADMIN = {
  [MODULE_LINK_TYPE.BUILD]: (moduleId: string, seriesId: string) =>
    `/ui/reinforcement/admin/${seriesId}/${moduleId}/build`,
  [MODULE_LINK_TYPE.INVITE_TRACK]: (moduleId: string, seriesId: string) =>
    `/ui/reinforcement/admin/${seriesId}/${moduleId}/invite-track`,
  [MODULE_LINK_TYPE.ANALYTICS]: (moduleId: string, seriesId: string, moduleName: string) =>
    `modules/${moduleId}/reinforcement/learners?gameType=reinforcement&inSeries=${seriesId}&name=${moduleName}`,
};

export const LEARNER = {};
